import Colors from '@root/brand/src/utils/colors';
import CoverageNonLiabilityLinkModal from '@root/quotes/src/components/modals/coverage-non-liability-link-modal';
import PropTypes from '@root/vendor/prop-types';
import React from '@root/vendor/react';
import rootCaretPointingUp from '@root/brand/src/assets/root-caret-pointingUp.svg';
import vehicleRentalFilledIcon from '@root/core/src/assets/vehicle-rental-filled.svg';
import { StyleSheet, Theme } from '@root/core/src/utils/styles';

const NjExtraPipLearnMoreModal = ({
  primaryBrandColor,
  infoBrandColor,
}) => (
  <CoverageNonLiabilityLinkModal
    infoBrandColor={infoBrandColor}
    linkText={'Learn more'}
    modalName={'NJ Extra PIP Learn More Modal'}
    primaryBrandColor={primaryBrandColor}
  >
    <h2 css={styles.header}>Non-Medical Expense</h2>
    <p css={styles.paragraph}>This coverage helps with everyday costs if an injury disrupts your life:</p>
    <ul css={styles.list}>
      <li css={styles.listItem}><strong>Income continuation</strong> pays a portion of your lost income if you can&apos;t work.</li>
      <li css={styles.listItem}><strong>Essential services</strong> covers things like childcare, cleaning, or deliveries.</li>
      <li css={styles.listItem}><strong>Funeral costs</strong> up to $2k are covered in case of death as a result of a covered accident.</li>
      <li css={styles.listItem}><strong>Death benefits</strong> provides up to $10k to your family members or estate if a covered accident is fatal.</li>
    </ul>
    <div css={styles.tipCard}>
      <div css={styles.iconWrapper}>
        <img
          alt={''}
          css={styles.icon}
          src={vehicleRentalFilledIcon}
        />
        <div css={styles.badgeBackground}>
          <img
            alt={''}
            css={styles.badgeCaret}
            src={rootCaretPointingUp}
          />
        </div>
      </div>
      <p css={styles.tipText}>Typically people keep this if they don&apos;t have strong disability coverage.</p>
    </div>
  </CoverageNonLiabilityLinkModal>
);

NjExtraPipLearnMoreModal.propTypes = {
  infoBrandColor: PropTypes.string,
  primaryBrandColor: PropTypes.string,
};

export default NjExtraPipLearnMoreModal;

const styles = StyleSheet.create({
  header: {
    ...Theme.heading2(),
    marginBottom: 24,
  },
  paragraph: {
    ...Theme.paragraph1(),
    marginBottom: 12,
  },
  list: {
    listStyleType: 'disc',
    marginBottom: 12,
    paddingLeft: 24,
  },
  listItem: {
    marginBottom: 8,
  },
  tipCard: {
    border: `1px solid ${Colors.gray20()}`,
    borderRadius: 6,
    padding: 12,
    marginTop: 8,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 12,
  },
  iconWrapper: {
    position: 'relative',
    flexShrink: 0,
    width: 60,
    height: 60,
    backgroundColor: Colors.gray10(),
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  icon: {
    width: 40,
    height: 40,
  },
  badgeBackground: {
    position: 'absolute',
    bottom: -6,
    right: 0,
    width: 24,
    height: 24,
    backgroundColor: Colors.white(),
    border: `1px solid ${Colors.gray20()}`,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  badgeCaret: {
    width: 12,
    height: 12,
    display: 'block',
  },
  tipText: {
    ...Theme.paragraph1(),
    flex: 1,
  },
});
